import { mixin as clickaway } from 'vue-clickaway';

import './QdShare.scss';
import template from './QdShare.vhtml';

export default {
	name: 'QdShare',
	template: template,
	mixins: [clickaway],
	props: {
		'url': {
			type: String,
			required: true,
		},
	},
	data: () => ({
		showDropdown: false,
	}),
	computed: {
		contentClasses: vm => {
			const dynamicClasses = {
				'o-square-btn__content--border': vm.showDropdown, 
			};

			return ['o-square-btn__content', dynamicClasses];
		},
		facebookLink: vm => `https://www.facebook.com/sharer/sharer.php?u=${vm.safeUrl}`,
		twitterLink: vm => `https://twitter.com/home?status=${vm.safeUrl}`,
		linkedInLink: vm => `https://www.linkedin.com/shareArticle?mini=true&url=${vm.safeUrl}&title=EnergiMetropol&summary=&source=`,
		safeUrl: vm => encodeURIComponent(vm.url),
	},
	methods: {
		toggleDropdown() {
			this.showDropdown = !this.showDropdown;
		},
		clickAway() {
			if (this.showDropdown) {
				this.showDropdown = false;
			}
		},
	},
};
